import type { Address } from '@sg/graphql-schema';

import { AddressType } from '../address.config';

/**
 * The address type is derived from the name, either home/work or custom.
 */
export const getAddressTypeFromAddress = (
  address?: Pick<Partial<Address>, 'name'> | null,
): AddressType => {
  if (address?.name === AddressType.HOME) return AddressType.HOME;

  if (address?.name === AddressType.WORK) return AddressType.WORK;

  return AddressType.CUSTOM;
};
